import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from './core/auth/auth.service';
import { AppSettingsService } from './shared/services/app-settings.service';
import { AnalyticsService } from './shared/services/analytics.service';
import { ClarityService } from './shared/services/clarity.service';
import { SnackbarMessageNormalizerService } from './shared/services/snackbar-message-normalizer.service';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent implements OnInit {
  title = 'The Big Data Showroom';

  constructor(
    private appSettingsService: AppSettingsService,
    private themeService: ThemeService,
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private clarityService: ClarityService,
    private snackbarMessageNormalizerService: SnackbarMessageNormalizerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.snackbarMessageNormalizerService.init();

    // Touch service so theme preference is applied during app bootstrap.
    this.themeService.getPreference();
    this.clarityService.init();

    // Default title
    document.title = this.title;

    // Update title when app settings arrive
    this.appSettingsService.settings$.subscribe({
      next: (settings) => {
        const appName = settings?.appName || this.title;
        document.title = appName;
      }
    });

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event) => {
      this.analyticsService.trackPageView(event.urlAfterRedirects);
    });

    this.authService.getCurrentUser().subscribe((user) => {
      this.analyticsService.setUserContext(user?.uid, user?.role);
      this.clarityService.setTag('user_role', user?.role || 'unknown');
      this.clarityService.setTag('auth_state', user ? 'authenticated' : 'anonymous');
    });

    window.addEventListener('unhandledrejection', (event) => {
      const reason = event.reason instanceof Error ? event.reason.message : String(event.reason || 'unknown');
      this.analyticsService.trackEvent('web_unhandled_rejection', {
        reason: reason.slice(0, 100)
      });
    });
  }
}

